module.exports = __webpack_public_path__ + "static/img/manual-35.315b219.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-35.png
// module id = ujbb
// module chunks = 4